export default "__VITE_ASSET__C1p4_vjE__"